import { useLingui } from '@lingui/react/macro'
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from 'designSystem/components/DropdownMenu'
import { PageRangeControls } from 'features/knowledgeDocumentViewer/components/toolbar/PageRangeControls'
import { Printer } from 'lucide-react'

type PrintDocumentMenuOptionsProps = {
  totalPages: number
  currentPageNumber: number
  pdfSignedUrl: string | undefined
  isPreparing: boolean
  onCurrentPage: () => void
  onFullDocument: () => void
  onRange: (startPage: number, endPage: number) => void
}

export function PrintDocumentMenuOptions({
  totalPages,
  currentPageNumber,
  pdfSignedUrl,
  isPreparing,
  onCurrentPage,
  onFullDocument,
  onRange,
}: PrintDocumentMenuOptionsProps) {
  const { t } = useLingui()
  const menuItemDisabled = !pdfSignedUrl || isPreparing

  return (
    <>
      <DropdownMenuItem onSelect={onCurrentPage} disabled={menuItemDisabled}>
        {t`Current page (${currentPageNumber})`}
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <PageRangeControls
        totalPages={totalPages}
        pdfSignedUrl={pdfSignedUrl}
        isDownloading={isPreparing}
        onRange={onRange}
        actionAriaLabel={t`Print page range`}
        actionIcon={<Printer size={14} strokeWidth={2} />}
      />
      <DropdownMenuSeparator />
      <DropdownMenuItem onSelect={onFullDocument} disabled={menuItemDisabled}>
        {t`Entire document (${totalPages} pages)`}
      </DropdownMenuItem>
    </>
  )
}
